import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    authUser: null,
    drawer: false,
    snackbar: false,
    snackbarText: '',
    snackbarColor: '',
    items: [],
    customers: [],
    locations: [],
    logTags: [],
    iothubs: null
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },

    setAuthUser (state, authUser) {
      state.authUser = authUser
    },

    setDrawer (state, value) {
      state.drawer = value
    },

    setSnackbar (state, value) {
      state.snackbar = value
    },

    setSnackbarText (state, text) {
      state.snackbarText = text
    },

    setSnackbarColor (state, color) {
      state.snackbarColor = color
    },

    setItems (state, items) {
      state.items = items
    },

    setCustomers (state, customers) {
      state.customers = customers
    },

    setLocations (state, locations) {
      state.locations = locations
    },

    setLogTags (state, tags) {
      state.logTags = tags
    },

    setIothubs (state, iothubs) {
      state.iothubs = iothubs
    }
  },
  actions: {
    async getAuthUser (context) {
      let response
      try {
        response = await axios.get(process.env.VUE_APP_API_URL + '/auth/user')

        console.log('getAuthUser response:', response.data)

        context.commit('setAuthUser', response.data)

        context.commit('setSnackbarText', 'Successfully logged in as ' + context.state.authUser.email)
        context.commit('setSnackbarColor', 'success')
        context.commit('setSnackbar', true)
      } catch (err) {
        console.log('Error trying to login user:', err)
        router.push('/login')
      }
    },

    async getLocations (context) {
      console.log('getLocations triggered')
      context.commit('setLoading', true)

      let response
      try {
        response = await axios.get(process.env.VUE_APP_API_URL + '/locations')

        context.commit('setLocations', response.data)
        context.commit('setLoading', false)
      } catch (err) {
        console.error('Error trying to getLocations', err)
        context.commit('setLoading', false)
      }
    },

    async getIothubs (context) {
      console.log('getIothubs triggered')
      context.commit('setLoading', true)

      let response
      try {
        response = await axios.get(process.env.VUE_APP_API_URL + '/iothubs')

        context.commit('setIothubs', response.data)
        context.commit('setLoading', false)
      } catch (err) {
        console.error('Error trying to getIothubs', err)
        context.commit('setLoading', false)
      }
    },

    async getLogTags (context) {
      console.log('getLogTags triggered')
      context.commit('setLoading', true)

      let response
      try {
        response = await axios.get(process.env.VUE_APP_API_URL + '/tags')

        context.commit('setLogTags', response.data)
        context.commit('setLoading', false)
      } catch (err) {
        console.error('Error trying to getLogTags', err)
        context.commit('setLoading', false)
      }
    },

    async getItemsByFilter (context, filter) {
      console.log('getItemsByFilter triggered')
      console.log(`filter: ${filter}, typeof: ${typeof filter}`)
      context.commit('setLoading', true)

      let response
      try {
        response = await axios.get(`${process.env.VUE_APP_API_URL}/items${filter ? '?filter=' + filter : ''}`)
        // response = await axios.get(process.env.VUE_APP_API_URL + '/items?filter=' + filter)

        context.commit('setItems', response.data)
        context.commit('setLoading', false)
      } catch (err) {
        console.error('Error trying to getItemsByFilter', err)
        context.commit('setLoading', false)
      }
    },

    async getCustomersByFilter (context, filter) {
      console.log('getCustomersByFilter triggered')
      context.commit('setLoading', true)

      let response
      try {
        response = await axios.get(
          process.env.VUE_APP_API_URL + '/customers?filter=' + filter
        )

        context.commit('setCustomers', response.data)
        context.commit('setLoading', false)
      } catch (err) {
        console.error('Error trying to getCustomersByFilter', err)
        context.commit('setLoading', false)
      }
    }
  },
  getters: {}
})
